import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from '@/modules/core/services/table-utils';

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/budget/statistic';
const serviceName = "Workload-Service: ";

const sortTableFields = ["created_at"];
const sortDatabaseFields = ["created_at"];

export default class BudgetStatisticService {

  static async getStatistics(paginator, filter, successF, errorF) {
    let params = createPageableParams(paginator.page,
      paginator.size,
      paginator.search,
      [paginator.sort],
      paginator.sortAsc,
      successF,
      errorF,
      sortTableFields,
      sortDatabaseFields);
    await WrapperService.post(`${API_URL}/${filter.year}/${filter.month + 1}?${params}`, filter, serviceName, successF, errorF);
  }

  static async getActiveYears(successF, errorF) {
    await WrapperService.get(API_URL + '/years', null, serviceName, successF, errorF);
  }

}